import clsx from "clsx";
import type { ReactNode } from "react";
import { NeedsAttention } from "./ListToolbar";
import type { NameTagConfig } from "./names";
import { ServiceM8Name } from "./NameTags";

/*
 * A record's name in a list (an item's, a bundle's), the same in each: its ServiceM8 name on one line, its tags' wording coloured
 * (cut short if need be: the whole name on hover), a mark before it (hidden) and after it what needs attention (one mark, a count
 * when more than one). Under it, small: the lines ServiceM8 shows under the name (e.g. special order) and anything else (`under`).
 * Archived: greyed and struck through.
 */
export function ListName(
    props: Readonly<{
        name: string;
        tags: NameTagConfig;
        problems: readonly string[];
        danger: boolean;
        /** Before the name (e.g. HiddenMark). */
        mark?: ReactNode;
        /** Archived (or retired): greyed and struck through. */
        struck?: boolean;
        /** Under the name, after its other lines (e.g. "4 in stock"). */
        under?: ReactNode;
        /** No name yet: what to say instead. */
        untitled?: string;
    }>,
) {
    const rest = props.name.includes("\n");
    return (
        <>
            <span className="flex min-w-0 items-center gap-1.5" title={props.name}>
                {props.mark}
                <span className={clsx("min-w-0 truncate font-semibold", props.struck && "text-muted line-through")}>
                    {props.name.trim() ? <ServiceM8Name name={props.name} tags={props.tags} only="first" /> : (props.untitled ?? "Untitled")}
                </span>
                <NeedsAttention problems={props.problems} danger={props.danger} />
            </span>
            {rest || props.under ? (
                <span className={clsx("mt-0.5 block truncate text-xs text-muted", props.mark ? "pl-5" : undefined)}>
                    {rest ? <ServiceM8Name name={props.name} tags={props.tags} only="rest" /> : null}
                    {rest && props.under ? " · " : null}
                    {props.under}
                </span>
            ) : null}
        </>
    );
}
